import TextColorMarkPlugin from './TextColorMarkPlugin';

export default [TextColorMarkPlugin];
